export const queryStringify = (
    obj: Object,
    options?: { separator?: string; prefix?: string },
) => {
    const defaultOptions = { separator: '&', prefix: '' };

    const { separator, prefix } = {
        ...defaultOptions,
        ...options,
    }

    return prefix + Object.entries(obj)
        .filter(([_, value]) => value)
        .map(([key, value]) => `${key}=${value}`)
        .join(separator);
}